import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

/** Shared classes for a safe vertical scroll pane inside a fixed-height shell. */
export const scrollRegionClassName =
  "min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain [-webkit-overflow-scrolling:touch]";

export type ScrollRegionProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};

/**
 * Fill remaining height and scroll when content is taller than the viewport.
 * Prefer denser layout first; use this as the safety net so nothing is clipped.
 */
export function ScrollRegion({
  children = null,
  className,
  ...props
}: ScrollRegionProps) {
  return (
    <div className={cn(scrollRegionClassName, className)} {...props}>
      {children}
    </div>
  );
}
